// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
}
.modal-header h2 {
  margin: 0;
  color: #333;
}

.modal-content {
  padding: 16px 24px;
  max-height: 500px;
  overflow-y: auto;
}

.search-container {
  margin-bottom: 16px;
}

.search-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}
.search-input:focus {
  outline: none;
  border-color: #007bff;
}

.branch-tables-list {
  max-height: 400px;
  overflow-y: auto;
}

.branch-table-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.branch-table-item:hover {
  background-color: #f5f5f5;
  border-color: #007bff;
}
.branch-table-item.selected {
  background-color: #e3f2fd;
  border-color: #007bff;
}

.table-info h4 {
  margin: 0 0 4px 0;
  color: #333;
  font-size: 16px;
}

.status {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: #dc3545;
  color: white;
}
.status.active {
  background-color: #28a745;
}

.selection-indicator fa-icon {
  color: #ccc;
  font-size: 20px;
}
.selection-indicator fa-icon.selected {
  color: #007bff;
}

.no-results {
  text-align: center;
  padding: 40px;
  color: #666;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
